import React from 'react'
import { BANKING_BOTTOM_CONTENT, DIGITAL_COURSE_PAGE_5, DIGITAL_DETAILS_PAGE_5, DIGITAL_HERO_PAGE_5 } from '../../../utils/constants'
import CourseAsideHero from '../../../reusable/CourseAsideHero'
import CoursesAside from '../../../reusable/Aside-courses'
import CourseCard from '../../../reusable/Course-card'
import Accordian from '../../../reusable/Accordian'
import PageDesc from '../../../reusable/PageDesc'
import { DIGITAL_ACCORDIAN_5 } from '../../../utils/courseConifg'

const DigitalPage_5 = () => {
  return (
    <div className='outlet-render'>
                         <CourseAsideHero  {...DIGITAL_HERO_PAGE_5}/>
      <CoursesAside {...DIGITAL_COURSE_PAGE_5}/>
      <CourseCard {...DIGITAL_DETAILS_PAGE_5}/>
      <Accordian {...DIGITAL_ACCORDIAN_5}/>
      <PageDesc {...BANKING_BOTTOM_CONTENT}/>
    </div>
  )
}

export default DigitalPage_5